const Rodape = () => {
    return (
        <section id="govsp-rodape"> 
            <link rel="stylesheet" type="text/css" href="https://www.saopaulo.sp.gov.br/barra-govsp/css/rodape-padrao-govsp.min.css"></link>                   
            <div class="container rodape">    
                <div class="logo-rodape">
                    <a href="https://www.saopaulo.sp.gov.br/">
                        <img src="https://www.saopaulo.sp.gov.br/barra-govsp/img/logo-rodape-governo-do-estado-sp.png" alt="site do Governo de São Paulo"  width="206" height="38"/>
                    </a>
                </div>
            
            </div>
        </section>
    )
}

export default Rodape